import { ValidationResult } from "@components/WizardCst/types";
import { validateConfig } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/config/enrollmentFieldsConfig";
import { StaticGroupWizardData } from "./types";

export const validateGroupInfo = (
  data: StaticGroupWizardData,
): ValidationResult => {
  const errors: Record<string, string> = {};
  if (!data.name?.trim()) errors.name = "required";
  return { valid: Object.keys(errors).length === 0, errors };
};

export const validateEnrollMode = (
  data: StaticGroupWizardData,
): ValidationResult => {
  const { valid, errors } = validateConfig(data.enrollConfig);
  return { valid, errors: errors as Record<string, string> };
};
